/* eslint-disable prefer-template */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'moment/min/locales';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from '../../../../styles/general.module.scss';
import { renderInfoForType } from '../../../../utils/helpers';
import Button from '../../../../components/button';
import { TRAINING_MANAGEMENT_SECTION_DETAILS } from '../../../../constants/RouterConstants';
import { fetchTrainingDetail, saveContentInfo, fetchTrainingDraft, downloadTrainingCertificate } from '../../redux/action';
import Loading from '../../../../components/loading';
import Status from './Status';

const Table = (props) => {
    const {
        info,
        actiontTrainingDraft,
        actionFetchTrainingDetails,
        actionDownloadCertificate,
        trainingData,
        trainingFetchAction,
        downloadCertificatetAction,
        trainingDraft,
        trainingDraftAction,
        trainingCertificate,
        activeTab
    } = props;

    const dateParse = date => renderInfoForType({ 'type': 'date' }, date, null, null);
    const history = useHistory();
    const [trainingId, setTrainingId] = useState(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (trainingFetchAction?.success === true && trainingDraftAction?.success === true && loading === true) {
            setLoading(false);
            if (trainingDraft?.tracking_info?.last_content_id) {
                let sectionId = trainingDraft?.tracking_info?.last_section_id;
                let subSectionId = trainingDraft?.tracking_info?.last_content_id;
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    +trainingId
                    +'/'
                    +sectionId
                    +'/'
                    +subSectionId
                );
            } else {
                let sectionId = trainingData?.sections[0]?.id;
                let subSectionId = trainingData?.sections[0]?.contents[0]?.id;
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    +trainingId
                    +'/'
                    +sectionId
                    +'/'
                    +subSectionId
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [trainingFetchAction, trainingDraftAction]);

    useEffect(() => {
        if (downloadCertificatetAction?.success === true) {
            setLoading(false);
            const a = document.createElement('a');
            a.href = trainingCertificate?.certificate_url;
            a.download = 'Certificate.pdf';
            a.click();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [downloadCertificatetAction]);

    const startTraining = (id, type, status) => {
        if (status !== 'in_progress' && type === 'scorm') {
            actiontTrainingDraft(id);
        } else if (type !== 'scorm') {
            actiontTrainingDraft(id);
        }
        actionFetchTrainingDetails(id);
        if (type === 'scorm') {
            history.push(
                TRAINING_MANAGEMENT_SECTION_DETAILS + id
            );
        } else {
            setTrainingId(id);
            if (trainingData === undefined || trainingFetchAction?.success !== true) {
                setLoading(true);
            } else {
                let sectionId = trainingData?.sections[0]?.id;
                let subSectionId = trainingData?.sections[0]?.contents[0]?.id;
                history.push(
                    TRAINING_MANAGEMENT_SECTION_DETAILS
                    +id
                    +'/'
                    +sectionId
                    +'/'
                    +subSectionId
                );
            }
        }
    };

    const downloadCertificate = (id) => {
        setLoading(true);
        actionDownloadCertificate(id);
    };

    return (
        <table className={styles.table}>
            <thead>
                <tr>
                    <th>
                        <FormattedMessage id="trainings.list.table.training_name" defaultMessage="Training Name" />
                    </th>
                    <th>
                        {activeTab === 'close'
                        ? <FormattedMessage id="trainings.list.table.completed.date" defaultMessage="Completed Date" />
                        : <FormattedMessage id="trainings.list.table.category" defaultMessage="Category" />}
                    </th>
                    <th>
                        <FormattedMessage id="trainings.list.table.next_Training_Date" defaultMessage="Next Training Date" />
                    </th>
                    <th>
                        <FormattedMessage id="trainings.list.table.status" defaultMessage="Status" />
                    </th>
                    <th />
                </tr>
            </thead>
            <Loading loadingStatus={loading} />
            <tbody>
                {!info.length > 0 ? (
                    <tr>
                        <td className="noTableData" colSpan={7}>
                            <FormattedMessage id="trainings.list.table.no_results" defaultMessage="There are no trainings" />
                        </td>
                    </tr>
                )
                    : (
                        info.map(training => (
                            <tr key={training.id || training.training.id}>
                                <td>{training.name || training.training.name}</td>
                                <td className={styles.date}>
                                    {training.status !== 'completed' ? (training?.category) : ''}
                                    {training.status !== 'active' ? dateParse(training?.completed_date || training?.training?.completed_date) : ''}

                                </td>
                                <td className={styles.date}>
                                    {training?.next_date || training?.training?.next_date
                                        ? dateParse(training?.next_date || training?.training?.next_date)
                                        : ''}
                                </td>
                                <td><Status item={training.status} /></td>
                                {training.status !== 'completed' && (
                                <td>
                                    <Button
                                        translationID="training.start.training"
                                        defaultText="Start"
                                        onClick={() => startTraining(
                                            training?.training?.id
                                            || training?.id, training?.training?.training_content_type
                                            || training?.training_content_type, training.status
                                        )}
                                        className={styles.startBtn}
                                    />
                                </td>
                                )}
                                {training.status === 'completed' && (
                                <td>
                                    <Button
                                        translationID="training.download.training"
                                        defaultText="Download Certificate"
                                        onClick={() => downloadCertificate(training?.id)}
                                        className={styles.startBtn}
                                    />
                                </td>
                                )}
                            </tr>
                        ))
                    )
                }
            </tbody>
        </table>
    );
};

Table.propTypes = {
    info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapDispatchToProps = dispatch => ({
    actionFetchTrainingDetails: (id) => {
        dispatch(fetchTrainingDetail(id));
    },
    actiontTrainingDraft: (id) => {
        dispatch(fetchTrainingDraft(id));
    },
    actionContentInfo: (id, data) => {
        dispatch(saveContentInfo(id, data));
    },
    actionDownloadCertificate: (id) => {
        dispatch(downloadTrainingCertificate(id));
    }
});

const mapStateToProps = state => ({
    trainingData: state.trainings.trainingDetail,
    trainingFetchAction: state.trainings.trainingFetchAction,
    trainingDraft: state.trainings.trainingDraft,
    trainingDraftAction: state.trainings.trainingDraftAction,
    downloadCertificatetAction: state.trainings.downloadCertificatetAction,
    trainingCertificate: state.trainings.trainingCertificate
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Table));
